import React, { useState } from 'react';
import { Drawer, Form, Input } from 'antd';
import PropTypes from 'prop-types';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { FormComponentProps } from 'antd/lib/form';
import { ConfirmationButtons } from '../../../common/form';
import { OrganisationMember } from '../../../../common/api/spidertracks-sdk/private/services/UserService';
import InvitedUsersEmailsField from './InvitedUsersEmailsField';

interface ComponentProps extends FormComponentProps {
  form: WrappedFormUtils;
  existingOrganisationMembers: OrganisationMember[];
  onClose: () => void;
  onCreate: (emailAddresses: string, message?: string) => void;
}

const InviteUsersDrawer: React.FC<ComponentProps> = ({
  onClose,
  onCreate,
  form,
  existingOrganisationMembers
}) => {
  const [emailTags, setEmailTags] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const [hasInvalidEmail, setHasInvalidEmail] = useState(true);
  const { getFieldDecorator } = form;

  const memberEmails = existingOrganisationMembers.map(member => member.email);

  const formSubmitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    form.validateFields();
    const emailAddresses = emailTags.join(',');
    const customMessage = form.getFieldValue('customMessage');
    onCreate(emailAddresses, customMessage);
    form.resetFields();
    setEmailTags([]);
  };

  return (
    <Drawer title="Invite" placement={'right'} visible={true} width={400} onClose={onClose}>
      <Form layout="vertical" onSubmit={formSubmitHandler}>
        <InvitedUsersEmailsField
          memberEmails={memberEmails}
          onEmailTagsChange={setEmailTags}
          emailTags={emailTags}
          disabled={isSaving}
          hasInvalidEmailCallback={setHasInvalidEmail}
        />
        <Form.Item
          label={'Custom message (optional):'}
          style={{
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {getFieldDecorator('customMessage', {
            initialValue: ''
          })(<Input.TextArea rows={4} disabled={isSaving} />)}
        </Form.Item>
        <ConfirmationButtons
          onClose={onClose}
          isSaving={isSaving}
          disabled={isSaving || hasInvalidEmail}
          text={'Invite'}
        />
      </Form>
    </Drawer>
  );
};

InviteUsersDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired,
  existingOrganisationMembers: PropTypes.array.isRequired
};

export default Form.create<ComponentProps>()(InviteUsersDrawer);
